import zh from './zh';
import en from './en';
import ja from './ja';

export default {
    zh,
    en,
    ja
};
